import env from 'common/env';

export const goEditor = (id: string) => {
  window.open(`${env.editorUrl}?projectId=${id}`);
};

export const goPlayLibrary = () => {
  window.open(`${env.dspUrl}/capital/game-play`);
};
export const goPfEditor = (id: string) => {
  window.open(`${env.editorUrl}?projectId=${id}&mode=block`);
};
